import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/home/dell/dev/lib/nb-form-element/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/home/dell/dev/lib/nb-form-element/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2592cf9530813ccff83136f285d36238.js')["default"];

var scope_2 = require('/home/dell/dev/lib/nb-form-element/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/73d27f756d6f4a714dee6e1eab3f7fa1.js')["default"];

var scope_3 = require('/home/dell/dev/lib/nb-form-element/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/753376d333cbe70e7c86e1d85af4e00b.js')["default"];

var scope_4 = require('/home/dell/dev/lib/nb-form-element/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dbc2082d63c34ed69b36dce370836872.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4);